export const LOGO_MAX_BYTES = 2 * 1024 * 1024;

export const logoImageUrl = (domain: string) =>
  `https://img.logo.dev/${encodeURIComponent(domain)}` +
  `?token=${encodeURIComponent(import.meta.env.VITE_LOGODEV_TOKEN ?? "")}` +
  "&width=800&height=400&format=png&fallback=404";

export const downloadLogo = async (domain: string): Promise<File> => {
  const res = await fetch(logoImageUrl(domain));
  if (!res.ok) throw new Error("We couldn't fetch that logo. Try another, or upload your own.");
  const blob = await res.blob();
  if (!blob.type.startsWith("image/") || blob.size === 0 || blob.size > LOGO_MAX_BYTES) {
    throw new Error("We couldn't use that logo. Try another, or upload your own.");
  }
  return new File([blob], `${domain}.png`, { type: blob.type });
};
